import billingModule from '../billing.module';

export default billingModule.constant('billingColorConstants', {
    blue: '#1e7ae3',
    green: '#5dd299',
    grey: '#c7d4df',
    red: '#f66161',
    yellow: '#f3b72f'
});



// WEBPACK FOOTER //
// ./modules/billing/constants/billingColor.constant.js